module.exports = __webpack_public_path__ + "static/media/nl.1976b201.svg";